/** Modo discreto (FUN 2026-10-02): botão de olho, anúncio do leitor de tela, preferências e aviso de exportação. Mesclado ao namespace `nucleo`. */
export const discretoPt = {
  discreto: {
    ocultar: 'Ocultar valores',
    mostrar: 'Mostrar valores',
    estadoLigado: 'Ligado',
    dica: '{{acao}} ({{atalho}})',
    valorOculto: 'valor oculto',
    campoOculto: '{{rotulo}}: valor oculto',
    ligado: 'Modo discreto ligado. Valores ocultos.',
    desligado: 'Modo discreto desligado. Valores visíveis.',
    preferencias: 'Preferências do modo discreto',
    noAparelho: 'Estas preferências ficam guardadas só neste aparelho.',
    atalho: 'Atalho do teclado: {{atalho}} liga e desliga o modo discreto em qualquer tela.',
    inatividade: 'Ligar sozinho depois de um tempo sem uso',
    inatividadeAjuda: 'Sem tocar no mouse nem no teclado por esse tempo, os valores ficam ocultos. Digitar ou clicar dentro do quadro de um link externo conta como uso; com o foco parado dentro do quadro, esse tempo só começa a contar depois de 15 minutos.',
    inatividadeDesligado: 'Desligado',
    minutos_one: '{{count}} minuto',
    minutos_other: '{{count}} minutos',
    nomes: 'Ocultar também nomes de pessoas e empresas',
    nomesAjuda: 'Mostra só as iniciais.',
    exportarTitulo: 'Modo discreto ligado',
    exportarAviso: 'O arquivo sai com os valores reais.',
    imprimirAviso: 'O certificado sai com o nome real.',
    copiarTitulo: 'Modo discreto ligado',
    copiarAviso: 'O texto copiado leva os valores reais.',
    secao: 'Modo discreto',
    secaoAjuda: 'Oculta valores, documentos e contatos na tela, como o olho dos apps de banco. O botão de olho na barra superior liga e desliga.',
  },
};
